import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

interface NavLink {
  to: string;
  label: string;
}

interface HeaderProps {
  appName: string;
  navLinks?: NavLink[];
}

const Header: React.FC<HeaderProps> = ({ appName, navLinks = [] }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/apps" className="header-home">← Apps</Link>
          <h1 className="header-title">{appName}</h1>
        </div>
        {navLinks.length > 0 && (
          <nav className="header-nav">
            {navLinks.map((link) => (
              <Link key={link.to} to={link.to} className="nav-link">
                {link.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
